import React, { useState } from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card, Tabs, Tab } from '@mui/material';

import OfferingGeneralInfo from './OfferingGeneralInfo';
import OfferingDiscounts from './OfferingDiscounts';
import OfferingIncludedProducts from './OfferingIncludedProducts';

function OfferingDetailsView({ product, onClose }) {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Card>
      <ArgonBox>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="offering details tabs">
          <Tab label="General Info" />
          <Tab label="Included Products" />
          <Tab label="Discounts" />
        </Tabs>
      </ArgonBox>
      <ArgonBox p={3}>
        {tabValue === 0 && <OfferingGeneralInfo product={product} />}
        {tabValue === 1 && <OfferingIncludedProducts product={product} />}
        {tabValue === 2 && <OfferingDiscounts product={product} />}
      </ArgonBox>
    </Card>
  );
}

export default OfferingDetailsView;
